import { render, staticRenderFns } from "./AppIconsAlerts.vue?vue&type=template&id=0da2d9e6&scoped=true"
import script from "./AppIconsAlerts.vue?vue&type=script&lang=js"
export * from "./AppIconsAlerts.vue?vue&type=script&lang=js"
import style0 from "./AppIconsAlerts.vue?vue&type=style&index=0&id=0da2d9e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da2d9e6",
  null
  
)

export default component.exports